import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 24007 24708"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0,.str1{stroke:#2b2a29;stroke-width:273.25}.fil0,.fil1{fill:#2b2a29}.fil1{fill-rule:nonzero}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M12005 2470 1663 12361c-195 186-429 356-711 356-279 0-494-165-668-366l-147-169v-579l150-171c18-19 35-39 52-59 90-103 180-206 279-301 3350-3207 6701-6413 10042-9609 300-301 625-606 936-895l409-381 427 399c3695 3534 7360 7101 11085 10604l25 24c56 52 109 104 155 165 256 335 227 795-73 1092-154 152-360 241-577 241-178 0-347-59-490-165-92-69-175-148-257-229-19-19-38-37-58-56L12005 2470zM18660 2518l-1579 1c-333 0-666-1-999-2-517-2-919-318-924-852-2-229 76-447 238-611 179-182 426-260 677-261 534 0 1068-1 1602-1l2722 1 1 1415c0 935 0 1871-2 2807 0 150-9 297-58 440-123 362-427 576-809 576-380 0-684-212-808-572-50-144-59-291-59-441-2-661-2-1323-2-1984v-516z"
        className="fil0 "
      />
      <path
        d="M3647 22191h9067l-881 1734H1933l-1-10511c-1-59-1-117 3-176 33-454 395-814 868-814 456 11 809 361 839 813 5 72 5 143 5 215v8739z"
        className="fil0 "
      />
      <g id="_2283699361584">
        <path
          d="M16448 16840c258 825 289 1635-213 2423-770 1208-1524 2426-2261 3655-130 217-213 509-197 759 27 435 303 729 735 850 447 124 824-14 1091-374 329-442 623-909 928-1368 932-1401 1859-2807 2799-4203 142-210 173-402 115-643-162-681-306-1367-456-2052-12-57-11-117-21-232 265 206 497 377 715 563 52 44 71 139 82 213 75 496 132 994 219 1487 93 527 532 794 1048 660 378-98 640-405 588-795-104-763-246-1521-386-2279-18-94-116-184-197-253-787-668-1566-1347-2377-1986-220-174-532-263-816-317-280-52-579-14-869-9-519 10-869 268-1060 743-283 706-551 1419-850 2118-66 156-213 309-363 393-426 241-875 442-1312 666-456 234-624 660-431 1070 196 419 658 568 1123 348 633-301 1270-595 1885-930 193-105 320-332 481-507z"
          className="fil1 "
        />
        <path
          d="M21411 24395c890 7 1365-797 984-1482-215-387-460-759-693-1137-562-913-1124-1826-1687-2737-209-339-294-339-519 2-293 443-579 890-880 1328-107 156-122 279-11 444 692 1024 1374 2055 2062 3082 205 307 483 494 744 500zM17074 12421c692 3 1266-567 1265-1256-1-675-572-1250-1247-1253-689-4-1264 569-1262 1259 1 681 564 1247 1244 1250z"
          className="fil1 "
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
